import { render, staticRenderFns } from "./TractGroupDialog.vue?vue&type=template&id=545f288e&"
import script from "./TractGroupDialog.vue?vue&type=script&lang=js&"
export * from "./TractGroupDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports